
import React from 'react';
import { styled } from '@core-ui/react-stitch';
import CloseIcon from '../components/CloseIcon';

interface CloseButtonProps  {
  ariaLabel: string,
  buttonSide: string,
  onClick: () => void
}

interface CloseButtonContainerProps {
  buttonSide: string,
}

const Container = styled.div<CloseButtonContainerProps>(({ buttonSide }: CloseButtonContainerProps) => ({
  position: 'absolute',
  ...buttonSide === 'right' ? { right: '-16%' } : { left: '-16%' },
  top: '10px',
}));

const Button = styled.button(() => ({
  background: 'transparent',
  border: 0,
}));

const CloseButton = ({ ariaLabel, onClick, buttonSide }: CloseButtonProps) => (
  <Container buttonSide={buttonSide}>
    <Button
      aria-label={ariaLabel}
      className="close_button"
      id="closeButton"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <CloseIcon />
    </Button>
  </Container>
);

export default CloseButton;
